import { openDB } from "idb";
// indexedDB.deleteDatabase("ShopDB");

const DB_NAME = "ShopDB";
const STORE_NAME = "products";

// ✅ Open IndexedDB and create object stores if not present
const dbPromise = openDB(DB_NAME, 9, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME);
    }
    if (!db.objectStoreNames.contains("banners")) {
      db.createObjectStore("banners");
    }
    if (!db.objectStoreNames.contains("product")) {
      db.createObjectStore("product");
    }
    if (!db.objectStoreNames.contains("series")) {
      db.createObjectStore("series"); // ✅ Add series store
    }
    if (!db.objectStoreNames.contains("productall")) {
      db.createObjectStore("productall"); // ✅ Add series store
    }
    if (!db.objectStoreNames.contains("promotional")) {
      db.createObjectStore("promotional"); // ✅ Add series store
    }
  },
});

// ✅ Save Products
export async function saveProducts(data) {
  try {
    const db = await dbPromise;
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    await store.put(data, "productList");
    await tx.done;
  } catch (error) {
    console.error("Error saving products:", error);
  }
}

// ✅ Get Products
export async function getProducts() {
  try {
    const db = await dbPromise;
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    return await store.get("productList");
  } catch (error) {
    console.error("Error getting products:", error);
    return null;
  }
}

// ✅ Banners
export async function saveBanners(data) {
  const db = await dbPromise;
  await db.put("banners", data, "bannerList");
}

export async function getBanners() {
  const db = await dbPromise;
  return await db.get("banners", "bannerList");
}

// ✅ Banners
// export async function saveBanners2(data) {
//   const db = await dbPromise;
//   await db.put("banners2", data, "bannerList2");
// }

// export async function getBanners2() {
//   const db = await dbPromise;
//   return await db.get("banners2", "bannerList2");
// }

// ✅ Banners
export async function savePro(data) {
  const db = await dbPromise;
  await db.put("product", data, "productList");
}

export async function getPro() {
  const db = await dbPromise;
  return await db.get("product", "productList");
}

// ✅ Banners
export async function saveProAll(data) {
  const db = await dbPromise;
  await db.put("productall", data, "allproductList");
}

export async function getProAll() {
  const db = await dbPromise;
  return await db.get("productall", "allproductList");
}

// ✅ Now for Series
export async function saveSeries(data) {
  const db = await dbPromise;
  await db.put("series", data, "seriesList");
}

export async function getSeries() {
  const db = await dbPromise;
  return await db.get("series", "seriesList");
}

// ✅ Now for Series
export async function savePromotional(data) {
  const db = await dbPromise;
  await db.put("promotional", data, "promotionalList");
}

export async function getPromotional() {
  const db = await dbPromise;
  return await db.get("promotional", "promotionalList");
}
